import React, { useEffect, useState } from 'react';
import AddOrderCommentButton from '../AddOrderCommentButton';
import LabeledTextArea from '../LabeledTextArea';
import { DefaultValues } from '../../../utils/constants';

export const OrderCommentContainerTestId = 'OrderCommentContainer-input';

export type OrderCommentProps = {
  labelText?: string;
  orderComment?: string;
  onOrderCommentUpdated?: (comment: string) => void;
};

const OrderComment: React.FC<OrderCommentProps> = ({
  orderComment = '',
  onOrderCommentUpdated,
  labelText = DefaultValues.DEFAULT_LABEL_TEXT,
}: OrderCommentProps) => {
  const [displayOrderCommentInput, setDisplayOrderCommentInput] =
    useState(false);

  useEffect(() => {
    setDisplayOrderCommentInput(orderComment.length > 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAddOrderCommentButtonClicked = (): void => {
    setDisplayOrderCommentInput(true);
  };

  const handleOrderCommentBlur = (
    e: React.FocusEvent<HTMLTextAreaElement>
  ): void => {
    if (onOrderCommentUpdated) {
      onOrderCommentUpdated(e.target.value);
    }
  };

  return (
    <div className="p-4" data-testid={OrderCommentContainerTestId}>
      {!displayOrderCommentInput && (
        <AddOrderCommentButton
          onAddOrderCommentClicked={handleAddOrderCommentButtonClicked}
        />
      )}
      {displayOrderCommentInput && (
        <div className="flex flex-row items-center sm:mb-5">
          <LabeledTextArea
            defaultValue={orderComment}
            label={labelText}
            name="misc.comment"
            maxlength={20000}
            height={5}
            width={40}
            onBlur={handleOrderCommentBlur}
          />
        </div>
      )}
    </div>
  );
};

export default OrderComment;
